<template>
  <div>
    <el-row class="map-row-list list" v-for="(map,index) in map_data" :key="'map'+index" @click.native="$emit('getUserSelectPlace', map_data[index])">
      <!-- <el-col :span="24" class="choose-map-from" >{{map_data[index].description}}</el-col> -->
      <el-col :span="24" class="text-body color-charcoal--text mb--2">{{map_data[index].description}}</el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
export default {
  props: {
    map_data: {
      default: () => []
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/components/map/MapList.vue